<span style="text-align: right">{{ value }}</span>
@if (value) {
  <span> {{ unitAbbrv }}</span>
}
